import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import DataListingComponent from "../../Component/DataListingComponent";
import { useLocation } from "react-router-dom";
import demoImg from "../../Assets/demo.png";
import view from "../../Assets/View.png";
import FoodTruckDetailsModal from "./MyBookingsModel";
import {  API_GET_USERID2 } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";

const PAGE_SIZE_OPTIONS = [15];
const UserBookingScreen = () => {
  const location = useLocation();
  const [bookingData, setBookingData] = useState([]);
  const [index, setIndex] = useState(0);
  const [IsLoading, setIsLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const [OpenDetailsModal, setOpenDetailsModal] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  let id = location.state;

  const getBookingData = async (page = 0, pageSize = PAGE_SIZE_OPTIONS[0]) => {
    try {
      setIsLoading(true);
      let count = page * pageSize;
      let res = await API_GET_USERID2(
        `${API_endspoints.getallbooking}?count=${count}&offset=${pageSize}`,
        id
      );
      if (res?.s) {
        const Rowdata = res?.r?.map((data, i) => ({
          rowid: i + 1,
          ...data,
        }));
        setBookingData(Rowdata);
        setTotalData(res?.c || 0);
      } else {
        setBookingData([]);
        setTotalData(0);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getBookingData(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const column = [
    {
      headerClassName: "super-app-theme--header",
      field: "rowid",
      headerName: "#",
      width: 50,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "",
      headerName: "Company Profile",
      width: 130,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              className="ImgHover"
              src={demoImg}
              alt="icon"
              height={40}
              width={40}
            />
          </Box>
        </Box>
      ),
    },
    {
      headerClassName: "super-app-theme--header",
      field: "company_name", // You can still define the field as a placeholder
      headerName: "Company Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "center",
      renderCell: (params) => {
        return <div>{params.row.company_details?.company_name || ""}</div>;
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "from_date",
      headerName: "Start Date",
      flex: 1,
      minWidth: 120,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "to_date",
      headerName: "End Date",
      flex: 1,
      minWidth: 120,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "total_budget",
      headerName: "Total Budget",
      flex: 1,
      minWidth: 120,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 130,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span
            style={{
              color:
                cell.value === 1
                  ? "green"
                  : cell.value === "0"
                  ? "orange"
                  : cell.value === "-1"
                  ? "red"
                  : "black",
              fontWeight: 600,
            }}
          >
            {cell.value === 1
              ? "Approved"
              : cell.value === 0
              ? "Pending"
              : "Canceled"}
          </span>
        </Box>
      ),
    },
    {
      headerClassName: "super-app-theme--header",
      field: "ViewDetails",
      headerName: "View Details",
      width: 130,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              onClick={() => {
                setOpenDetailsModal(true);
                setIndex(cell.row.rowid - 1);
              }}
              className="ImgHover"
              src={view}
              alt="icon"
              height={24}
              width={24}
            />
          </Box>
        </Box>
      ),
    },
  ];

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };
  return (
    <>
      <Box sx={{ height: "calc(100% - 40px)" }}>
        <DataListingComponent
          data={bookingData ?? []}
          PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
          loading={IsLoading}
          totalData={totalData}
          page={page}
          Footer={true}
          columns={column}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
        />
      </Box>
      <FoodTruckDetailsModal
        setOpen={setOpenDetailsModal}
        open={OpenDetailsModal}
        data={bookingData}
        index={index}
      />
    </>
  );
};

export default UserBookingScreen;
